import Image from 'next/image';
import dayjs from 'dayjs';
import parse from 'html-react-parser';

import { cardColors, textColors } from '@/src/constants/wall.constant';
import {socialCardKeys} from '@/src/constants/socialcard.constant'
import ClassNames from '@/src/components/componentHelper/ClassNames';
// import { useState } from 'react';

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const PictureCard = ({ cardItem,cardWidth, fontStyle, cardBackgroundObject, darkModeEnabled=false, cardFontColor, darkCardTheme, smallSize, shortenText, refresh, isDateTimeDisabled, ratingColor}) => {

   // const [imageSize, setSmageSize] = useState({
   //    width: 1,
   //    height: 1
   //   });
        
   return(
         <div className={ClassNames(darkModeEnabled ? "border-none" : "border border-gray-200 bg-white", "relative z-0 transition-all w-full card-holder ")} style={{maxWidth: "40rem", minWidth:cardWidth}}>
         <div 
         className="card social-card-style select-none relative transition-all"
         style={cardBackgroundObject? cardBackgroundObject :{}}
         >
           
    
            <div className="tweet-content relative " style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.15em":"1.0em",lineHeight: !smallSize? 1.5: 1.7 }}>
              {
               cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!=='' &&
               <div className={ClassNames("content mb-3",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')} dir="auto">
    {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent])
                  :
                  null
               }
               </div>
               }
               {
                  cardItem[socialCardKeys.screenshotImage] &&
                  <div className="flex justify-center w-full h-full"  style={{width: '100%', height:'100%', position: 'relative'}}>

                     <img onLoad={()=>refresh()} loading='lazy' className="w-auto rounded-md " width="100%" height="100%" priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius:'8px', objectFit: 'contain' }} src={cardItem[socialCardKeys.screenshotImage]} alt="Picture" />

                  </div>
               }

{/* {
                  cardItem[socialCardKeys.screenshotImage] &&
                  <div className="flex justify-center w-full"  >

<img className="w-auto rounded-md " loading='lazy' style={{ width: '100%', height: '400px', objectFit: 'contain' }} src={cardItem[socialCardKeys.screenshotImage]} alt="Post Preview" />


                  </div>
               } */}
            </div>
            <div>

               <div className="flex">
       
               <div className={(fontStyle && fontStyle!=='')?`font-${fontStyle}`:''} style={!darkModeEnabled?{color: (cardFontColor || textColors.black.secondary), fontSize: 14}:{color: (cardFontColor || textColors.light.secondary), fontSize: 14}}>
                  <span>{(!isDateTimeDisabled && cardItem[socialCardKeys.messageTime])?dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY'):null}</span>
               </div>
               </div>

            </div>
         </div>
         </div>
      )
   }

export default PictureCard;

